import ConnectionBadge from './ConnectionBadge';
import LiveIndicator from '../shared/LiveIndicator';
import { useConnectionState } from '../../hooks/useBLE';

export default function Header() {
  const state = useConnectionState();

  return (
    <header className="flex items-center justify-between px-4 py-2 border-b border-white/5 bg-scope-bg/90 backdrop-blur-sm flex-shrink-0">
      <div className="flex items-center gap-2">
        <div className="w-6 h-6 rounded bg-scope-trace/20 flex items-center justify-center">
          <svg viewBox="0 0 24 24" className="w-4 h-4 text-scope-trace" fill="none" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M9.348 14.652a3.75 3.75 0 0 1 0-5.304m5.304 0a3.75 3.75 0 0 1 0 5.304m-7.425 2.121a6.75 6.75 0 0 1 0-9.546m9.546 0a6.75 6.75 0 0 1 0 9.546" />
          </svg>
        </div>
        <span className="text-sm font-bold text-white">Sentinel</span>
        <LiveIndicator active={state === 'connected'} />
      </div>
      <ConnectionBadge />
    </header>
  );
}
